import {
  CaretDownFilled,
  CaretUpFilled,
  PlusOutlined,
  UploadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Form,
  InputNumber,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import useCountry from "../../../../lib/hooks/useCountry";
import useCurrentStatus from "../../../../lib/hooks/useCurrentStatus";
import { routes } from "../../../../routes";
import { ThaiRangePicker } from "../../../../components/common/thaiDatePicker";
import {
  searchFutureCustomerAutocomplete,
  searchListByCompany,
  searchListContacts,
} from "../../../../services/customerFutures";

// const { Title } = Typography;
const { Text } = Typography;
const { Option } = Select;

const Search = ({
  yearList,
  dropDownRegionGroup,
  dropDownPurpost,
  onSearch,
  handleChangeInputNumber,
  dropDownCompanyType,
  dropDownIndustryType,
  dropDownAreaType,
  dropDownKnowChannel,
  onChangeRangePicker,
  setDateFrom,
  setDateTo,
  onExportFile,

  waterLower,
  waterUpper,
  setWaterLower,
  setWaterUpper,

  areaLower,
  areaUpper,
  setAreaLower,
  setAreaUpper,

  setElectLower,
  setElectUpper,
  electLower,
  electUpper,

  setWastLower,
  setWastUpper,
  wastLower,
  wastUpper,

  setAreaSizeByRaiMin,
  setAreaSizeByRaiMax,
  areaSizeByRaiMin,
  areaSizeByRaiMax,

  setAreaSizeByNganMin,
  setAreaSizeByNganMax,
  areaSizeByNganMin,
  areaSizeByNganMax,

  setAreaSizeByWaMin,
  setAreaSizeByWaMax,
  areaSizeByWaMin,
  areaSizeByWaMax,

  roleUser,
  id,
}) => {
  const navigate = useNavigate();
  const [countries, optionCountries] = useCountry();
  const [current_status, options] = useCurrentStatus();
  const [searchForm] = Form.useForm();
  const [searchCollapse, setSearchCollapse] = useState(false);
  const [dataInstitution, setDataInstitution] = useState([]);
  const [multiOptions, setMultiOptions] = useState([]);
  const [multiValue, setMultiValue] = useState("");
  const [factoryNameTH, setFactoryNameTH] = useState("");
  const [factoryNameEN, setFactoryNameEN] = useState("");
  const [futureCustomerId, setFutureCustomerId] = useState("");
  const [companyAutocomplete, setCompanyAutocomplete] = useState([]);
  const [contactAutocomplete, setContactAutocomplete] = useState([]);

  const handleChange = (value) => {
    //console.log(`Selected: ${value}`);
  };

  const handleCollape = () => {
    setSearchCollapse(!searchCollapse);
  };

  //เลือกชื่อนามสกุล
  const onSelectFutureCustomerId = (value, option) => {
    setFutureCustomerId(option.futureCustomerId);
  };

  //เลือกชื่อบริษัท TH
  const onSelectFactoryNameTH = (value, option) => {
    setFactoryNameTH(option);
  };

  //เลือกชื่อบริษัท EN
  const onSelectFactoryNameEN = (value, option) => {
    setFactoryNameEN(option);
  };

  const getPanelValue = async (searchText) => {
    const res = await searchFutureCustomerAutocomplete(searchText);
    const { objectValue } = res.data;

    if (res?.data?.code === "0000") {
      const mapValue = objectValue.map((data) => {
        const foundCompanyName =
          _.get(data, "companyNameTh") + "," + _.get(data, "companyNameEn");
        const foundContactName = _.get(data, "contactName");
        const foundCountry = _.get(data, "countryNameTh");

        const concatText = foundCompanyName + foundContactName + foundCountry;
        return {
          ...data,
          value: concatText,
          id: _.get(data, "futureCustomerId"),
          key: _.get(data, "futureCustomerId"),
        };
      });

      setMultiOptions(mapValue);
    } else {
      setMultiOptions([]);
    }
  };

  const getListCompany = async (searchText) => {
    const res = await searchListByCompany(searchText);
    const { objectValue } = res.data;

    if (res?.data?.code === "0000") {
      const regularExpressPattern = /^[a-zA-Z0-9\s]+$/;
      const isEn = regularExpressPattern.test(searchText);
      const mapValue = objectValue.map((data, index) => {
        const companyNameEn = _.get(data, "companyNameEn");
        const companyNameTh = _.get(data, "companyNameTh");

        return {
          ...data,
          value: isEn ? (companyNameEn || companyNameTh) : (companyNameTh || companyNameEn),
          id: index,
          key: index,
        };
      });

      setCompanyAutocomplete(mapValue);
    } else {
      setCompanyAutocomplete([]);
    }
  };

  const getListContact = async (searchText) => {
    const res = await searchListContacts(searchText);
    const { objectValue } = res.data;

    if (res?.data?.code === "0000") {
      setContactAutocomplete(objectValue);
    } else {
      setContactAutocomplete([]);
    }
  };

  useEffect(() => {
    getListCompany("");
  }, []);

  useEffect(() => {
    getListContact("");
  }, []);

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center ">
              <Text
                level={4}
                style={{ marginTop: 15 }}
                className="headder-text-customer"
              >
                คลังข้อมูลลูกค้าอนาคต
              </Text>
              <div>
                <Space>
                  {(roleUser[0]?.isAll || roleUser[0]?.isExport) && (
                    <Button
                      onClick={(event) => {
                        onExportFile();
                      }}
                    >
                      <UploadOutlined /> Export Excel
                    </Button>
                  )}
                  {(roleUser[0]?.isAll || roleUser[0]?.isCreate) && (
                    <Button
                      type="primary"
                      onClick={() =>
                        // navigate(routes.add_customer_future, {
                        navigate(routes.select_channel_add_customer_future, {

                          state: {
                            id: 1,
                            action_type: "CREATE",
                          },
                        })
                      }
                    >
                      <PlusOutlined /> เพิ่มข้อมูล
                    </Button>
                  )}
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={searchForm}
        style={{
          padding: 20,
          backgroundColor: "#FCFCFC",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
        }}
        onFinish={(value) =>
          onSearch({
            ...value,
            futureCustomerId: futureCustomerId ? futureCustomerId : undefined,
          })
        }
        colon={false}
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"yearOfBudgets"}>
              <Select
                mode="multiple"
                placeholder="ปีงบประมาณ"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {yearList?.map((item, i) => {
                  return (
                    <Option key={i} value={item.value}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={16}></Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"companyType"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามประเภทการจัดตั้งบริษัท"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {dropDownCompanyType.map((option, i) => {
                  return (
                    <Option key={i} value={option.dataId}>
                      {option.dataDetailTh}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"nationalityList"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามสัญชาติ"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {dropDownRegionGroup.map((option, i) => {
                  return (
                    <Option key={i} value={option.dataId}>
                      {option.dataDetailTh}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"industryType"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามกลุ่มอุตสาหกรรม"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {dropDownIndustryType.map((option, i) => {
                  return (
                    <Option key={i} value={option.dataId}>
                      {option.dataDetailTh}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name="companyName">
              {/* <Input placeholder="ชื่อบริษัท" /> */}
              <AutoComplete
                filterOption={true}
                options={companyAutocomplete}
                onSearch={(text) => getListCompany(text)}
              >
                <Input placeholder="ชื่อบริษัท" prefix={<SearchOutlined />} />
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name="contactName">
              {/* <Input placeholder="ชื่อผู้ติดต่อ" /> */}
              <AutoComplete
                filterOption={true}
                options={contactAutocomplete}
                onSearch={(text) => getListContact(text)}
              >
                <Input
                  placeholder="ชื่อผู้ติดต่อ"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col>
          {/*  */}
          <Col className="gutter-row" span={8}>
            <Form.Item name="currentStatus">
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="สถานะปัจจุบัน"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
                options={options}
              />
            </Form.Item>
          </Col>
          {/*  */}
          {/*  */}
          <Col className="gutter-row" span={8}>
            <Form.Item name="customerRegion">
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="สัญชาติลูกค้า"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
                options={optionCountries}
              />
            </Form.Item>
          </Col>

          <Divider style={{ margin: 0 }} />

          {searchCollapse && (
            <>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  name={"contactDateFromTO"}
                  label="กลุ่มลูกค้าตามระยะเวลาการติดต่อ"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <ThaiRangePicker
                      placeholder={["DD/MM/YYYY", "DD/MM/YYYY"]}
                      onChange={onChangeRangePicker}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="กลุ่มลูกค้าตามปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={waterLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "waterLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={waterUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "waterUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="กลุ่มลูกค้าตามปริมาณการใช้ไฟฟ้า"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={electLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "electLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={electUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "electUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="กลุ่มลูกค้าตามปริมาณน้ำเสีย"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={wastLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "wastLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={wastUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "wastUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Divider style={{ margin: 0 }} />
              <Col className="gutter-row" span={14}>
                <Form.Item
                  label="ตามขนาดพื้นที่ที่ประกอบกิจการ (ไร่, งาน, วา)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="ไร่"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByRaiMin}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByRaiMin");
                      }}
                    />
                    <InputNumber
                      placeholder="งาน"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByNganMin}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByNganMin");
                      }}
                    />
                    <InputNumber
                      placeholder="วา"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByWaMin}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByWaMin");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="ไร่"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByRaiMax}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByRaiMax");
                      }}
                    />
                    <InputNumber
                      placeholder="งาน"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByNganMax}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByNganMax");
                      }}
                    />
                    <InputNumber
                      placeholder="วา"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByWaMax}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByWaMax");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <span className="box-border-clound"></span>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label="ตามขนาดพื้นที่ที่ประกอบกิจการ (ตารางเมตร)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={areaLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaMasterLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={areaUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaMasterUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Divider style={{ margin: 0 }} />

              <Col className="gutter-row" span={8}>
                <Form.Item name={"areaType"}>
                  <Select
                    mode="multiple"
                    placeholder="ตามประเภทพื้นที่ที่ต้องการ"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  >
                    {dropDownAreaType.map((option, i) => {
                      return (
                        <Option key={i} value={option.dataId}>
                          {option.dataDetailTh}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item name={"isInvestmentAdvice"}>
                  <Select
                    mode="multiple"
                    placeholder="วัตถุประสงค์ในการติดต่อ"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  >
                    {dropDownPurpost.map((option, i) => {
                      return (
                        <Option key={i} value={option.dataId}>
                          {option.dataDetailTh}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item name={"channels"}>
                  <Select
                    mode="multiple"
                    placeholder="ช่องทางการทราบข้อมูล กนอ."
                    onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  >
                    {dropDownKnowChannel.map((option, i) => {
                      return (
                        <Option key={i} value={option.dataId}>
                          {option.dataDetailTh}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleCollape}>
                {!searchCollapse ? <CaretDownFilled /> : <CaretUpFilled />}
              </Button>
              <Button
                onClick={() => {
                  searchForm.resetFields();
                  setDateTo("");
                  setDateFrom("");

                  setWaterLower("");
                  setWaterUpper("");
                  setAreaLower("");
                  setAreaUpper("");
                  setElectLower("");
                  setElectUpper("");
                  setWastLower("");
                  setWastUpper("");
                  setAreaSizeByRaiMin("");
                  setAreaSizeByRaiMax("");
                  setAreaSizeByNganMin("");
                  setAreaSizeByNganMax("");
                  setAreaSizeByWaMin("");
                  setAreaSizeByWaMax("");

                  onSearch({});
                }}
              >
                ล้างข้อมูล
              </Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
